(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mbc-core"), require("mbc-flag"), require("mbc-legend"));
	else if(typeof define === 'function' && define.amd)
		define(["mbc-core", "mbc-flag", "mbc-legend"], factory);
	else if(typeof exports === 'object')
		exports["mbc-vertical-bar"] = factory(require("mbc-core"), require("mbc-flag"), require("mbc-legend"));
	else
		root["mbc-vertical-bar"] = factory(root["mbc-core"], root["mbc-flag"], root["mbc-legend"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 130);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),

/***/ 111:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(31);


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Given a path it extract a value from a complex deep object.
 *
 * @param {Object} obj
 * @param {String} path
 * @returns Object's value found in the given path.
 */

function getPath(obj, path) {
    var index, prefix, subpath;
    if (!obj || !path || typeof path !== "string" || path === "") {
        return;
    }

    index = path.indexOf(".");
    if (index === -1) {
        return obj[path];
    } else {
        prefix = path.substring(0, index);
        subpath = path.substring(index + 1);
        return getPath(obj[prefix], subpath);
    }
}

/**
 * Copy source object properties into a target one.
 *
 * @export
 * @param {Object} target Target object.
 * @param {Object} source Source Object
 */
var copy = function copy(target) {
    var key, source;

    if (!target) {
        return;
    }

    for (var i = 1; i < arguments.length; i++) {
        source = arguments[i];
        for (key in source) {
            if (source.hasOwnProperty(key)) {
                target[key] = source[key];
            }
        }
    }

    return target;
};

/**
 * Extracts a value using an accessor or the same value if no accessor.
 * @param {Object} item Contains the value.
 * @param {Function|String}? accessor Accesor function or field that contains the value.
 * @param {Object} params Parameters to pass to the accesor function.
 * @return {Object} Value.
 */
var extract = function extract(item, accessor, params) {
    var value;
    if (typeof accessor === "undefined") {
        value = item;
    } else if (typeof accessor === "function") {
        value = accessor(item, params);
    } else if (typeof accessor === "string") {
        value = item[accessor];
    }

    return value;
};

/**
 * Clones and object.
 *
 * @export
 * @param {Object} target Object toclone.
 * @returns {Object} Cloned object.
 */
var clone = function clone(target) {
    if (target === undefined || target === null) {
        throw new TypeError("Cannot convert first argument to object");
    }

    var to = Object(target);
    for (var i = 1; i < arguments.length; i++) {
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) {
            continue;
        }

        var keysArray = Object.keys(Object(nextSource));
        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
                to[nextKey] = nextSource[nextKey];
            }
        }
    }

    return to;
};

/**
 * If just the value is passed return a boolean indicated is the value is undefined.
 * If the second parameter exists if value is undefined retunrs the second parameter, if not returns the value.
 * @param {Obect} value Object to evaluate.
 * @param {Object} defaultValue Object to return in case vale¡ue is undefined.
 */
var isUndefined = function isUndefined(value, defaultValue) {
    if (typeof defaultValue !== "undefined") return typeof value === "undefined" ? defaultValue : value;else return typeof value === "undefined";
};

/**
 * Check if the given value is not a number then return null, if it is a number return the number.
 * @param {Object} val Value to check.
 * @returns {undefined|Number}
 */
var NaNtoNull = function NaNtoNull(val) {
    if (typeof val !== "number" || isNaN(val) || val === Infinity) {
        return null;
    } else {
        return val;
    }
};

/**
 * Method to get the boolean value, if not it returnd a default value.
 * @param {Object} value Value to check if it is a boolean.
 * @param {Boolean} defaultValue Default value in case value is not a boolean.
 * @returns {Boolean}
 */
var getBoolean = function getBoolean(value, defaultValue) {
    return typeof value === "boolean" ? value : defaultValue;
};

var assign = function assign(target) {
    // .length of function is 2
    if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
            // Skip over if undefined or null
            for (var nextKey in nextSource) {
                // Avoid bugs when hasOwnProperty is shadowed
                if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                    to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
};

module.exports = {
    clone: clone,
    copy: copy,
    extract: extract,
    getBoolean: getBoolean,
    isUndefined: isUndefined,
    NaNtoNull: NaNtoNull,
    path: getPath,
    assign: assign
};

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



__webpack_require__(111);

var _barChart = __webpack_require__(94);

var _barChart2 = _interopRequireDefault(_barChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _barChart2.default;

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Core = __webpack_require__(0);
var Utils = Core.Utils;
var mds_constants = Utils.colors.mds_constants;

function BenchmarksMixin() {}

/**
 * This method draws the bar char benchmark lines.
 */

BenchmarksMixin.prototype.drawSegmentedBenchmarks = function (benchmarksData) {
    var height = this.get("benchmarksHeight");
    var data = benchmarksData[0];
    var scales = this.get("scales");
    var xScale = scales.scale("x");
    var yScale = scales.scale("y1");
    var layer = this.get("canvas").layer("layer-benchmarks");
    var benchmarks = layer.selectAll(".benchmark").data(data.series);
    var barPadding = this.get("barGroupPadding");
    var barWidth = xScale.rangeBand() - barPadding;

    var x = function x(d, i) {
        return xScale(xScale.domain()[i]) + barPadding / 2;
    };

    var y = function y(d) {
        return yScale(d) - Math.floor(height / 2);
    };

    var h = function h(d) {
        return d === null ? 0 : height;
    };

    benchmarks.enter().append("rect").classed("benchmark", true).attrs({
        width: barWidth,
        height: h,
        x: x,

        y: y,

        fill: this.get("dottedBenchmarks") ? 'none' : this.get("benchmarksColor")
    }).on("mouseover", this.get("dispatch").hover);

    benchmarks.attrs({
        width: barWidth,
        height: h,
        x: x,

        y: y,

        fill: this.get("dottedBenchmarks") ? 'none' : this.get("benchmarksColor")
    });

    benchmarks.exit().remove();

    if (this.get("dottedBenchmarks")) {
        benchmarks.attr("stroke-dasharray", this.get("dottedDashDimensions"));
        benchmarks.attr("stroke-linecap", "round");
        benchmarks.attr("stroke-width", this.get("dottedStrokeWidth"));
        benchmarks.attr("stroke", this.get("benchmarksColor"));
    }
};

BenchmarksMixin.prototype.drawBenchmarks = function (benchmarksData) {
    var height = this.get("benchmarksHeight");
    var data = benchmarksData;
    var scales = this.get("scales");
    var xScale = scales.scale("x");
    var yScale = scales.scale("y1");
    var layer = this.get("canvas").layer("layer-benchmarks");

    var xoffset = xScale.rangeBand() / 2;
    var benchmarkDots = layer.selectAll(".benchmarkDot").data(data[0].series);
    var r = function r(d) {
        return d === null ? 0 : 3.5;
    };

    benchmarkDots.enter().append("circle").classed("benchmarkDot", true).attr("cx", function (d, i) {
        return xScale(xScale.domain()[i]) + xoffset;
    }).attr("cy", function (d) {
        return yScale(d) - Math.floor(height / 2);
    }).attr("r", r).attr("fill", "black");

    benchmarkDots.classed("benchmarkDot", true).attr("cx", function (d, i) {
        return xScale(xScale.domain()[i]) + xoffset;
    }).attr("cy", function (d) {
        return yScale(d) - Math.floor(height / 2);
    }).attr("r", r).attr("fill", "black");

    benchmarkDots.exit().remove();

    var generateLine = function generateLine(list) {
        var height = this.get("benchmarksHeight");
        var scales = this.get("scales");
        var xScale = scales.scale("x");
        var yScale = scales.scale("y1");
        var xoffset = xScale.rangeBand() / 2;
        var path = "";
        var hasStartedMoving = false;
        for (var i = 0; i < list.length; i++) {
            var value = list[i];
            if (value !== null) {
                var x = xScale(xScale.domain()[i]) + xoffset,
                    y = yScale(value) - Math.floor(height / 2);
                var currentCoordinate = !hasStartedMoving ? "M" + x + "," + y : "L" + x + "," + y;
                hasStartedMoving = true;
                path += currentCoordinate;
            }
        }
        return path;
    };

    var linePath = generateLine.call(this, data[0].series);
    var benchmarks = layer.selectAll(".line").data(data);
    benchmarks.enter().append("path").classed("line", true).attr("d", linePath).attr("stroke", mds_constants["color"].black).attr("stroke-width", 2).attr("fill", "none").on("mouseover", this.get("dispatch").hover);

    benchmarks.classed("line", true).attr("d", linePath).attr("stroke", mds_constants["color"].black).attr("stroke-width", 2).attr("fill", "none");

    benchmarks.exit().remove();

    if (this.get("dottedBenchmarks")) {
        benchmarks.attr("stroke-dasharray", this.get("dottedDashDimensions"));
        benchmarks.attr("stroke-linecap", "round");
        benchmarks.attr("stroke-width", this.get("dottedStrokeWidth"));
    }
};

module.exports = BenchmarksMixin;

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var core = __webpack_require__(0);
var TooltipPlugin = __webpack_require__(1);
var Utils = core.Utils;
var assign = __webpack_require__(3).assign;
var mds_constants = Utils.colors.mds_constants;

function Tooltip() {}

Tooltip.defaultTemplate = "<div class=\"tooltip-inner tooltip-flag\">\n                            <div class=\"tooltip-title\"><p><%this.datapoint%></p></div>\n                            <div class=\"tooltip-body tooltip-table\">\n                                <%for(var index in this.data){%>\n                                    <%if (this.data.hasOwnProperty(index)) {%>\n                                        <div class=\"cell tooltip-row\">\n                                            <div class=\"tip-cell-icon tooltip-cell\"\n                                                <%if(this.data[index].benchmark){%>class=\"benchmark\"<%} %>\n                                                style=\"<%if(this.data[index].benchmark){%> height: 2px; margin-bottom: 3px; <%} %>\n                                                <%if(!this.data[index].benchmark || !this.dottedBenchmarks){%> background-color: <% this.data[index].color %> <%} else {%> background-color: tranparent; border-top: 2px dotted " + mds_constants["color"].black + " <%} %>\n                                                \">\n                                            </div>\n                                            <div class=\"tip-cell-name tooltip-cell\" style=\"max-width: <%this.maxWidthTextCell%>px\"><%this.data[index].name%></div>\n                                            <div class=\"tip-cell-data tooltip-cell\"><%this.data[index].value%></div>\n                                        </div>\n                                    <%}%>\n                                <%}%>\n                            </div>\n                        </div>";

/**
 * Highlights hover over each group or bars
 */

Tooltip.prototype.toggleHighlight = function (index) {
    var grouped = this.get("selection").selectAll(".bar-group")[0];

    grouped.forEach(function (bar, i) {
        if (i === index) {
            var n = bar.childNodes.length;
            for (var j = 0; j < n; j++) {
                var rect = bar.childNodes[j];
                if (rect.id === "highlighted") {
                    rect.removeAttribute("id");
                } else {
                    rect.id = "highlighted";
                }
            }
        }
    });
};

/**
 * Adds the mouse hover zones to trigger the tooltip.
 */
Tooltip.prototype.addTooltipZones = function () {
    var canvas = this.get("canvas");
    var data = this.get("dataForTooltips");
    var benchmarks = this.get("data").get(this.get("benchmarksDataSource"));
    var scales = this.get("scales");
    var xScale = scales.scale("x");
    var rangeBand = xScale.rangeBand();
    var benchmarkColor = this.get("benchmarksColor");
    var layer, benchmarksName;
    var formatFn = this.tickFormat(this.get("y1TickFormat"));
    var hiddenBars = this.get("hideBars");
    var padding = this.get("barGroupPadding");

    var x = function x(d, i) {
        // bar-group has a transform that shifts elements, must include this translation when using the retrieved padding value
        return xScale(xScale.domain()[i]) + padding / 2;
    };

    canvas.removeLayer("mbc-bar-chart-tooltip", "front");
    layer = canvas.layer("mbc-bar-chart-tooltip", "front");

    if (benchmarks.length) {
        benchmarksName = benchmarks[0].displayName;
        benchmarks = benchmarks[0].series;
        data.forEach(function (d, i) {
            var val = benchmarks[i];
            var isNull = val === null || typeof val === "undefined";
            d.benchmark = {
                name: benchmarksName,
                value: isNull ? "N/A" : Utils.string.convertDashToEnDash(formatFn(val)),
                oValue: val,
                color: benchmarkColor,
                benchmark: true
            };
        });
    }

    var zones = layer.selectAll(".mbc-bar-chart-tooltip-zone").data(data);

    // Enter
    zones.enter().append("rect").classed("mbc-bar-chart-tooltip-zone", true).attrs({
        opacity: 0,
        width: rangeBand - padding,
        height: canvas.height(),
        x: x,
        y: 0
    }).on("mouseover", function (d, i) {
        if (!hiddenBars) {
            this.toggleHighlight(i);
        }
    }.bind(this)).on("mouseout", function (d, i) {
        if (!hiddenBars) {
            this.toggleHighlight(i);
        }
    }.bind(this));
};

/**
 * @method resetZones
 * @desc Clear all the tooltip zones
 * @return undefined
 */
Tooltip.prototype.resetZones = function () {
    var canvas = this.get("canvas");
    var layer = canvas.layer("mbc-bar-chart-tooltip", "front");

    layer.selectAll('rect').remove();
};

/**
 * Fill all data into the current tooltip template.
 */

Tooltip.prototype.compileTemplate = function (d) {
    var _this = this;
    var dataMan = this.get("data");
    var template = this.get("tooltipTemplate");
    var y1DS = this.get("y1DataSource");
    var context = assign({}, this.__attributes);
    var seriesData = [];
    var positive = [];
    var negative = [];
    var colorFn = this.color.bind(this);
    var formatFn;
    var datapoint = Utils.string.unmask(d.point);
    var y1TickFormat = _this.tickFormat(_this.get("y1TickFormat"));
    var y2TickFormat = _this.tickFormat(_this.get("y2TickFormat"));

    if (this.get("xAxisDateLabel")) {
        var format = this.get("tooltipTimeFormat") || d3.time.format("%x");
        datapoint = format(new Date(datapoint));
    }

    context.datapoint = datapoint;

    var barsHidden = this.get("hideBars");
    if (!barsHidden) {
        d.values.forEach(function (value) {
            formatFn = dataMan.inGroup(value.series, y1DS) ? y1TickFormat : y2TickFormat;
            var val = value.value;
            var isNull = val === null || typeof val === "undefined";
            var item = {
                name: value.series,
                value: isNull ? "N/A" : Utils.string.convertDashToEnDash(formatFn(val)),
                oValue: val,
                color: colorFn(value.index),
                benchmark: false
            };
            seriesData.push(item);
            if (val >= 0) {
                positive.unshift(item);
            } else {
                negative.push(item);
            }
        });
        if (this.get("stacked")) {
            seriesData = positive.concat(negative);
        }
    }

    if (d.benchmark) {
        seriesData.push(d.benchmark);
    }

    context.data = seriesData;
    var longestValue = Utils.string.getLongestTextStringWidth(context.data);
    context.maxWidthTextCell = 164 - longestValue; // 200 max width - 10 icon with - 26 in total padding
    return Utils.string.template(template, context);
};

/**
 * Create a new Tooltip Plugin object and it is binded to the chart hovering zones.
 */

Tooltip.prototype.addTooltip = function () {
    var canvas = this.get("canvas");
    var selection = canvas.layer("mbc-bar-chart-tooltip", "front").selectAll(".mbc-bar-chart-tooltip-zone");
    var template = this.get("tooltipTemplate");

    if (template) {
        var tooltip = TooltipPlugin({
            position: "top-right",
            namespace: this.get("id"),
            autoposition: canvas
        }).template(this.compileTemplate.bind(this));
        selection.call(tooltip.bind());
        this.set("tooltipObject", tooltip);
    }
};

/**
 * Initializes the tooltip.
 */
Tooltip.prototype.initTooltip = function () {
    var benchmarks = this.get("data").get(this.get("benchmarksDataSource"));
    var barsHidden = this.get("hideBars");

    this.resetZones();

    if (!barsHidden || barsHidden && benchmarks.length) {
        this.addTooltipZones();
        this.addTooltip();
    }
};

module.exports = Tooltip;

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Core = __webpack_require__(0);
var Legend = __webpack_require__(2);
var Benchmarks = __webpack_require__(92);
var Tooltip = __webpack_require__(93);

var Chart = Core.Chart;
var Utils = Core.Utils;
var Classes = Core.Classes;
var DateAxis = Core.Axes.DateAxis;
var mds_constants = Utils.colors.mds_constants;

/**
 * Vertical Bar Chart.
 *
 * @example
 * // Extension example:
 * var BarChart = require("mbc-bar-chart");
 *
 * var NewExtendedBarChart = BarChart.extend({
 *   ...
 * });
 *
 * @example
 * // Use example:
 * var BarChart = require("mbc-bar-chart");
 *
 * var barchart = new BarChart(<options>);
 * d3Container.datum(data).call(barchart.init());
 *
 * @class
 * @extends Chart
 */
var GroupedBarchart = Chart.extend(Benchmarks, Legend, Tooltip,
/**
 * @lends GroupedBarchart.prototype
 **/
{
    /** @type {String} */
    id: "mbc-vertical-bar-chart", // Also used as class for this chart type.
    /** @type {Number} */
    screenMinHeight: 100, // container min-height
    /** @type {Number} */
    benchmarksHeight: 2,
    /** @type {String} */
    benchmarksColor: mds_constants["color"].black,
    /** @type {String} */
    benchmarksDataSource: "Benchmarks",
    /** @type {String} */
    benchmarksDisplayName: "Benchmarks",
    /** @type {Number} */
    breakpoint: 600,
    /** @type {Boolean} */
    hasBenchmarks: false,
    /** @type {Boolean} */
    legend: true,
    /** @type {Number} */
    legendMaxWidth: 120,
    /** @type {String} */
    legendPosition: "right",
    /** @type {Boolean} */
    stacked: false,
    /** @type {Number} */
    ticksNumber: 4,
    /** @type {Boolean} */
    ticksSymmetrical: true,
    /** @type {Array} */
    tickValues: null,
    /** @type {Array} */
    x0Domain: null,
    /** @type {String} */
    xAxisOrient: "bottom",
    /** @type {Array} */
    xAxisLabels: null,
    /** @type {String} */
    xAxisLabelsDatasource: "xLabels",
    /** @type {Array} */
    xDomain: null,
    /** @type {String} */
    xDomainDatasource: "xDomain",
    /** @type {Boolean} **/
    xAxisDateLabel: false,
    /** @type {String} **/
    timeLevel: 'monthly',
    /** @type {String} */
    y1Abbreviation: null,
    /** @type {Boolean|String} */
    y1AxisLabel: false,
    /** @type {String} */
    y1AxisOrient: "left",
    /** @type {String} */
    y1DataSource: "y1AxisData",
    /** @type {String} */
    y1TicksAlign: "right",
    /** @type {Function|String} */
    y1TickFormat: ",.2f",
    /** @type {String} */
    y1TickSymbol: "$",
    /** @type {Boolean} */
    y2: false,
    /** @type {String} */
    y2Abbreviation: null,
    /** @type {Boolean} */
    y2AxisLabel: false,
    /** @type {String} */
    y2AxisOrient: "left",
    /** @type {String} */
    y2DataSource: "y2AxisData",
    /** @type {String} */
    y2TicksAlign: "right",
    /** @type {Function|String} */
    y2TickFormat: ",.2f",
    /** @type {String} */
    y2TickSymbol: "$",
    /** @type {Number} */
    yAxesLabelWidth: 15,
    /** @type {Number} */
    yAxesLabelPadding: 3,
    /** @type {Number} */
    yAxesSpacing: 12,
    /** @type {Array} */
    yDomain: null,
    /** @type {Number} */
    yPadding: 12,
    /** @type {Number} */
    yPaddingBig: 12,
    /** @type {Number} */
    yPaddingSmall: 6,
    /** @type {Number} */
    yTickMargin: 6,
    /** @type {Number} */
    yTickSize: 35,
    /** @type {Boolean} */
    tooltip: true,
    /** @type {Number} */
    tooltipDecimals: 2,
    /** @type {String} */
    tooltipTemplate: Tooltip.defaultTemplate,
    /** @type {Boolean} */
    defaultBenchmarkStyle: true,
    /** @type {Boolean} */
    hideBars: false,
    /** @type {Number} */
    dottedStrokeWidth: 2,
    /** @type {String} */
    dottedDashDimensions: "1, 5",
    /** @type {Boolean} */
    dottedBenchmarks: false,
    /** @type {Boolean} */
    showGrayBands: false, //config whether show gray bands.
    /** @type {Number} */
    y1TickWidth: 0, //config axis-y1 width, if not passing this value, chart will calculate  appropriate width.
    /** @type {Boolean} */
    showZeroLine: true, //Control grid zero line opacity
    allowDuplicateDataGroups: false, //Allows data groups to have same name but plot in different groups
    showLabelsAtBreakpoint: false, //show the x-axis labels at small breakpoint
    showSubLabelsAtBreakpoint: false,
    /**
     * @override
     * Prepare the data for the chart.
     * @param {Object} data Raw data.
     */
    setData: function setData(data) {

        var _this = this;
        var dataManager = this.get("data");
        var benchmarksSource = this.get("benchmarksDataSource");
        var benchmarksData = Utils.object.path(data, benchmarksSource);
        var xAxisLabels = Utils.object.path(data, this.get("xAxisLabelsDatasource"));

        this.set("xDomain", Utils.object.path(data, this.get("xDomainDatasource")).map(function (d, i) {
            return Utils.string.mask(d, i);
        }));

        if (!Utils.array.hasNulls(xAxisLabels)) {
            this.set("xAxisLabels", xAxisLabels);
        }

        Utils.object.path(data, this.get("y1DataSource")).forEach(function (sObject) {
            dataManager.set(sObject.name, sObject.values, this.get("y1DataSource"));
        }.bind(this));

        dataManager.parser(this.get("y1DataSource"), function (data, domain) {
            var map = domain.map(function (point, i) {

                var obj = { point: point };
                var values = data;
                var positive;
                var negative;
                if (_this.get("stacked")) {
                    positive = data.filter(function (value) {
                        return value.series[i] >= 0;
                    }).reverse();
                    negative = data.filter(function (value) {
                        return value.series[i] < 0;
                    });
                    values = negative.concat(positive);
                }
                obj.values = values.map(function (value) {
                    return {
                        point: point,
                        series: value.name,
                        value: value.series[i],
                        index: value.index
                    };
                });

                return obj;
            });

            return map;
        }, this.get("xDomain"));
        if (benchmarksData) {
            this.set("benchmarksDisplayName", benchmarksData.name);
            this.get("data").uset({
                name: benchmarksSource,
                series: benchmarksData.values,
                display: benchmarksData.name
            });
        }
    },

    /**
     * @override
     */
    beforeDraw: function beforeDraw() {

        this.redoCanvas();

        var dataManager = this.get("data");
        var canvas = this.get("canvas");
        var tickValues = this.get("tickValues");
        var y1LabelText = this.get("y1AxisLabel");
        var y2LabelText = this.get("y2AxisLabel");
        var yAxesLabelWidth = this.get("yAxesLabelWidth");
        var yDomain = this.get("yDomain");
        var domain;

        if (!y1LabelText && !y2LabelText) {
            canvas.set("yAxesLabelWidth", 0);
        } else {
            canvas.set("yAxesLabelWidth", yAxesLabelWidth);
        }

        canvas.set("tickSize", this.get("yTickSize"));
        canvas.set("axesSpacing", this.get("yAxesSpacing"));
        canvas.set("axesPadding", this.get("yPadding"));
        canvas.set("margin", this.getMargins());

        if (!yDomain && (!tickValues || tickValues.length < 2)) {
            domain = dataManager.calculateDomain({
                groups: [this.get("y1DataSource"), this.get("benchmarksDataSource")],
                symmetrical: this.get("ticksSymmetrical"),
                steps: this.get("ticksNumber"),
                stacked: this.get("stacked")
            });
            this.set("_yDomain", domain);
        } else if (!yDomain) {
            this.set("_yDomain", [tickValues[0], tickValues[tickValues.length - 1]]);
        } else {
            this.set("_yDomain", yDomain);
        }

        if (this.get("y2")) {
            this.set("y2Domain", [0, 100]);
        } else {
            this.get("axes").remove("y2");
        }

        if (canvas.get("outerWidth") <= this.get("breakpoint")) {
            this.set("yPadding", this.get("yPaddingSmall"));
        } else {
            this.set("yPadding", this.get("yPaddingBig"));
        }

        this.set("x0Domain", this.getX0Domain());
        this.setBarGroupPadding();
    },

    /**
     * @override
     */
    draw: function draw() {
        if (this.get("legend")) {
            var dataManager = this.get("data");
            var bars = dataManager.queryGroup(this.get("y1DataSource"));
            var benchmarks = dataManager.queryGroup(this.get("benchmarksDataSource"));
            var data = bars.concat(benchmarks);
            this.invokeLegend({
                chart: "verticalBar",
                data: data,
                benchmarkStyle: this.get("dottedBenchmarks"),
                benchmarkColor: this.get("benchmarksColor"),
                benchmarkSpan: "benchmarks"
            });
            this.get("canvas").update();
        }

        this.buildScales();
        this.drawBars();
        this.buildAxes();
        this.drawAxes();
        this.drawGrid();

        if (this.get("tooltip")) {
            this.initTooltip();
        }
    },

    /**
     * @override
     */
    afterDraw: function afterDraw(options) {
        var canvas = this.get("canvas");
        var axes = canvas.get("axesGroup");
        var xAxisOrient = this.get("xAxisOrient");
        var noTicksRecalc = options && options.noTicksRecalc;
        var domain, first, last, height;

        this.adjustYLabels();

        var showBars = this.get("showLabelsAtBreakpoint");
        if (!this.get("xAxisDateLabel") && canvas.get("outerWidth") <= this.get("breakpoint") && !showBars) {
            axes.selectAll("." + Classes.AXIS + "-x text").style("display", "none");
            domain = this.get("xDomain");
            first = Utils.string.unmask(domain[0]);
            last = Utils.string.unmask(domain[domain.length - 1]);
            height = canvas.height() + 15;
            axes.append("text").attrs({
                x: 5,
                y: xAxisOrient === "bottom" ? height : -9,
                class: "x-alternative-first",
                "text-anchor": "start"
            }).text(first);
            axes.append("text").attrs({
                x: canvas.width() - 6,
                y: xAxisOrient === "bottom" ? height : -9,
                class: "x-alternative-last",
                "text-anchor": "end"
            }).text(last);
        }

        if (this.get("legend")) {
            canvas.watch("outerWidth", function (newValue, oldValue) {
                this.checkBreakpoints(newValue, oldValue);
            }.bind(this));
        }

        if (!noTicksRecalc) {
            this.updateTickWidths(axes);
        }

        this.addYAxisCenterTick();
    },

    /**
     * To render the middle tick line on Y-axes when domain range is negative to positive
     */
    addYAxisCenterTick: function addYAxisCenterTick() {
        var canvas = this.get("canvas");
        var axisY1 = canvas.layer("mbc-axis-y1", "axes").selectAll(".tick")[0];
        var axisY2 = canvas.layer("mbc-axis-y2", "axes").selectAll(".tick")[0];
        var domain = this.get("_yDomain");
        var tickValues = this.get("tickValues") || Utils.chart.getTickValues(this.get("_yDomain"));
        var middleTickIndex = Math.floor(tickValues.length / 2);
        var negativePositiveDomain = domain[0] < 0 && domain[1] > 0;

        if (axisY1 && axisY1.length && negativePositiveDomain && canvas.get("outerHeight") < 200) {
            for (var i = 0; i < axisY1.length; i++) {
                if (i === middleTickIndex) {
                    axisY1[i].setAttribute("class", axisY1[i].getAttribute("class") + " middle-tick");
                    if (axisY2 && axisY2.length) {
                        axisY2[i].setAttribute("class", axisY2[i].getAttribute("class") + " middle-tick");
                    }
                }
            }
        }
    },

    /**
     * This method is intended for Y axes tick width recalculation.
     */
    updateTickWidths: function updateTickWidths(axes) {
        var maxWidth = 0;
        var ticks = [];
        var y1TickWidth = this.get('y1TickWidth');
        var el;
        if (y1TickWidth) {
            this.set("yTickSize", y1TickWidth);
        } else {
            d3.selectAll(".mbc-axis.mbc-axis-y1 .tick text").each(function () {
                el = d3.select(this);
                ticks.push(el.text());
            });

            maxWidth = Utils.svg.getGreaterSVGTextWidth(axes.select("." + Classes.AXIS + "-x"), ticks);
            this.set("yTickSize", maxWidth + this.get("yTickMargin"));
        }

        this.set("ticksUpdated", true);
        this.update({ noTicksRecalc: true });
    },

    /**
     * Get the data and call for draw stacked or gruped bar chart as stated in 'stacked' attribute.
     */
    drawBars: function drawBars() {
        var data = this.get("data").get(this.get("y1DataSource"));
        var benchmarks = this.get("data").get(this.get("benchmarksDataSource"));
        var scales = this.get("scales");
        var layer = this.get("canvas").layer(this.get("id"));
        var group = layer.selectAll(".bar-group").data(data);

        if (this.get("stacked")) {
            layer.classed({
                stacked: true,
                grouped: false
            });
            data = this.stackValues(data);
            this.drawStackedBars(data, scales, group);
        } else {
            layer.classed({
                stacked: false,
                grouped: true
            });
            this.drawGroupedBars(data, scales, group);
        }

        this.set("dataForTooltips", data);

        if (benchmarks.length) {
            if (this.get("defaultBenchmarkStyle") === true) {
                this.set("dottedBenchmarks", false);
                this.drawSegmentedBenchmarks(benchmarks);
            } else {
                this.set("dottedBenchmarks", true);
                this.drawBenchmarks(benchmarks);
            }
        } else {
            this.get("canvas").layer("layer-benchmarks").remove();
        }
    },

    /**
     * This method add a stacked value for each positives and negatives point values.
     * This values are setted on 'value0' attribute for positives and 'value1' for negatives;
     * @param {Array} data Contains all series values by Data Point (X axis)
     * @return {Array} The same array with the stacked values added to each point values.
     */
    stackValues: function stackValues(data) {
        return data.map(function (d) {
            var negative = 0; // last values
            var positive = 0;
            d.values = d.values.map(function (value) {
                value.value0 = positive;
                value.value1 = negative;
                if (value.value >= 0) {
                    positive += value.value;
                } else if (value.value < 0) {
                    negative += value.value;
                }

                return value;
            });

            return d;
        });
    },

    /**
     * Draws the stacked bar chart bars.
     */
    drawStackedBars: function drawStackedBars(data, scales, group) {
        var xScale = scales.scale("x");
        var yScale = scales.scale("y1");
        var bars, heightFn, yFn, fill;
        var barPadding = this.get("barGroupPadding");

        fill = function (d) {
            return this.color(d.index);
        }.bind(this);

        heightFn = function heightFn(d) {
            if (d.value >= 0) {
                return yScale(d.value0) - yScale(d.value0 + d.value);
            } else {
                return Math.abs(yScale(d.value1) - yScale(d.value + d.value1));
            }
        };

        yFn = function yFn(d) {
            if (d.value >= 0) {
                return yScale(d.value0 + d.value);
            } else {
                return yScale(d.value1);
            }
        };

        group.enter().append("g").attr("class", "bar-group");

        group.exit().remove();

        bars = group.selectAll("rect").data(function (d) {
            return d.values;
        }).attr("id", "");

        bars.attrs({
            width: xScale.rangeBand() - barPadding,
            x: function (d) {
                return xScale(d.point) + barPadding / 2;
            }.bind(this),
            y: yFn,

            height: heightFn,

            opacity: this.get("hideBars") ? 0 : 0.8,

            fill: fill.bind(this)
        });

        bars.enter().append("rect").attrs({
            width: xScale.rangeBand() - barPadding,
            x: function (d) {
                return xScale(d.point) + barPadding / 2;
            }.bind(this),

            y: yFn,

            height: heightFn,

            opacity: this.get("hideBars") ? 0 : 0.8,

            fill: fill.bind(this)
        }).on("mouseover", this.get("dispatch").hover).on("mouseout", this.get("dispatch").mouseout).on("click", this.get("dispatch").click);

        bars.exit().remove();
    },

    /**
     * Draws the grouped chart bars.
     */
    drawGroupedBars: function drawGroupedBars(data, scales, group) {
        var _this = this;
        var x0Scale = scales.scale("x0");
        var xScale = scales.scale("x");
        var yScale = scales.scale("y1");
        var barPadding = this.get("barGroupPadding");
        var bars, fill;

        fill = function fill(d) {
            return this.color(d.index);
        };

        group.enter().append("g").attr("class", "bar-group").attr("transform", function (d) {
            return "translate(" + xScale(d.point) + ", 0)";
        });

        group.attr("transform", function (d) {
            return "translate(" + xScale(d.point) + ", 0)";
        });

        group.exit().remove();

        bars = group.selectAll("rect").data(function (d) {
            return d.values;
        }).attr("id", "");

        bars.enter().append("rect").attrs({
            width: x0Scale.rangeBand(),
            x: function x(d) {
                var x0Value = _this.get('allowDuplicateDataGroups') ? d.series + d.index : d.series;
                return x0Scale(x0Value) + barPadding / 2;
            },

            y: function y(d) {
                return yScale(Math.max(0, d.value));
            },

            height: function height(d) {
                return Math.abs(yScale(0) - yScale(d.value));
            },

            opacity: this.get("hideBars") ? 0 : 0.8,

            fill: fill.bind(this)
        }).on("mouseover", this.get("dispatch").hover).on("mouseout", this.get("dispatch").mouseout).on("click", this.get("dispatch").click);
        bars.attrs({
            width: x0Scale.rangeBand(),
            x: function x(d) {
                var x0Value = _this.get('allowDuplicateDataGroups') ? d.series + d.index : d.series;
                return x0Scale(x0Value) + barPadding / 2;
            },

            y: function y(d) {
                return yScale(Math.max(0, d.value));
            },

            height: function height(d) {
                return Math.abs(yScale(0) - yScale(d.value));
            },

            opacity: this.get("hideBars") ? 0 : 0.8,

            fill: fill.bind(this)
        });

        bars.exit().remove();
    },

    /**
     * Draws the axes into the canvas and its labels.
     */
    drawAxes: function drawAxes() {
        var axes = this.get("axes");
        var canvas = this.get("canvas");

        canvas.drawAxes(axes);

        this.drawAxesLabels();
    },

    /**
     * Appends labels for Y axes and also appends the X axes sub labels.
     */
    drawAxesLabels: function drawAxesLabels() {
        var canvas = this.get("canvas");
        var y1LabelText = this.get("y1AxisLabel");
        var y2LabelText = this.get("y2AxisLabel");
        canvas.layer(Classes.AXES + "-labels", "axes").remove();
        canvas.layer(Classes.AXES + "-xlabels", "axes").remove();
        var layer = canvas.layer(Classes.AXES + "-labels", "axes");
        var xlayer = canvas.layer(Classes.AXES + "-xlabels", "axes");
        var xScale = this.get("scales").scale("x");
        var xAxisOrient = this.get("xAxisOrient");
        var xLabels = this.get("xAxisLabels");
        var xTexts;

        if (y1LabelText) {
            this.appendYLabel(layer, "y1", y1LabelText);
        }

        if (this.get("y2") && y2LabelText) {
            this.appendYLabel(layer, "y2", y2LabelText);
        }

        var isDateXAxis = this.get('xAxisDateLabel');
        // X sub labels
        var shouldShowLabels = canvas.get("outerWidth") > this.get("breakpoint") || this.get('showSubLabelsAtBreakpoint') && xLabels;

        if (shouldShowLabels) {
            xTexts = xlayer.selectAll(".mbc-x-label").data(xScale.domain());
            xTexts.enter().append("g").classed("mbc-x-label", true).attr("transform", function (d) {
                var x = xScale(d) + xScale.rangeBand() / 2;
                var y = xAxisOrient === "bottom" ? canvas.height() + 35 : -25;
                return "translate(" + x + ", " + y + ")";
            }).append("text").text(function (d, i) {
                var label = "";
                if (i < xLabels.length) {
                    label = xLabels[i] || "";
                }

                return label;
            }).attrs({
                "text-anchor": "middle"
            });
        }

        if (isDateXAxis) {
            this.get("dateAxis").drawSubLabels(canvas);
        }
    },

    /**
     * This method draws the backgroud grid in the chart.
     */
    drawGrid: function drawGrid() {
        var scales = this.get("scales");
        var y1Scale = scales.scale("y1");
        var xScale = scales.scale("x");
        var y1Axis = this.get("axes").axis("y1");
        var canvas = this.get("canvas");
        var tickValues = y1Axis.tickValues();
        var backGroup = canvas.get("backGroup");
        var yValue = canvas.height();
        var grid = backGroup.selectAll("." + Classes.GRID_LINE).data(tickValues);
        var bottomLines;
        var hiddenBars = this.get("hideBars");
        var isSmallHeight = this.get("canvas").height() <= this.get("screenMinHeight");
        var padding = this.get("barGroupPadding");

        if (this.get("showGrayBands")) {
            this.drawGrayBands();
        }

        var extractor = function extractor(d) {
            return y1Scale(d);
        };
        var showZeroLine = this.get("showZeroLine");

        grid.enter().append("line").attrs({
            x1: 0 + padding,
            x2: canvas.width() - padding,
            y1: extractor,
            y2: extractor,
            class: function _class(d, i) {
                var appendClass = "";
                if (i === 0) {
                    appendClass = "first";
                }
                if (i === tickValues.length - 1) {
                    appendClass = "last";
                }
                return Classes.GRID_LINE + " " + appendClass;
            },

            opacity: function opacity(d, i) {
                if (isSmallHeight) {
                    // if container's height is small, only show last grid line
                    return i !== tickValues.length - 1 && !hiddenBars ? 0 : 1;
                } else {
                    return (!showZeroLine && d === 0 || i === 0) && !hiddenBars ? 0 : 1;
                }
            }
        });

        grid.attrs({
            x1: 0 + padding / 2,
            x2: canvas.width() - padding / 2,
            y1: extractor,
            y2: extractor,
            opacity: function opacity(d, i) {
                if (isSmallHeight) {
                    // if container's height is small, only show last grid line
                    return i !== tickValues.length - 1 && !hiddenBars ? 0 : 1;
                } else {
                    return (!showZeroLine && d === 0 || i === 0) && !hiddenBars ? 0 : 1;
                }
            }
        });

        grid.exit().remove();

        // Draw bottom llines
        if (y1Scale.domain()[0] < 0) {
            bottomLines = backGroup.selectAll(".bottom-line").data(xScale.domain());
            var linesGap = this.get("showGrayBands") ? 0 : this.get("barGroupPadding");
            bottomLines.enter().append("line").classed("bottom-line", true).attr({
                x1: function x1(d) {
                    return xScale(d) + linesGap / 2;
                },

                x2: function x2(d) {
                    return xScale(d) + xScale.rangeBand() - linesGap / 2;
                },

                y1: yValue,
                y2: yValue
            });
            bottomLines.classed("bottom-line", true).attr({
                x1: function x1(d) {
                    return xScale(d) + linesGap / 2;
                },

                x2: function x2(d) {
                    return xScale(d) + xScale.rangeBand() - linesGap / 2;
                },

                y1: yValue,
                y2: yValue
            });

            bottomLines.exit().remove();
        }
    },

    drawGrayBands: function drawGrayBands() {
        var xScale = this.get("scales").scale("x");
        var canvas = this.get("canvas");
        var canvasHeight = canvas.height();
        var backGroup = canvas.get("backGroup");
        var barPadding = this.get("barGroupPadding");
        var length = xScale.domain().length;
        //draw back ground bars
        var gridBars = backGroup.selectAll(".grid-bar").data(xScale.domain());
        gridBars.enter().append("rect").classed("grid-bar", true).attr({
            x: function (d, i) {
                return i === 0 ? xScale(d) + barPadding / 2 : xScale(d);
            }.bind(this),
            y: 0,
            width: function width(d, i) {
                return i === 0 || i === length - 1 ? xScale.rangeBand() - barPadding / 2 : xScale.rangeBand();
            },
            height: canvasHeight
        });
        gridBars.classed("grid-bar", true).attr({
            x: function (d, i) {
                return i === 0 ? xScale(d) + barPadding / 2 : xScale(d);
            }.bind(this),
            y: 0,
            width: function width(d, i) {
                return i === 0 || i === length - 1 ? xScale.rangeBand() - barPadding / 2 : xScale.rangeBand();
            },
            height: canvasHeight
        });

        gridBars.exit().remove();
    },

    /**
     * Configure all axes used in the chart.
     */
    buildAxes: function buildAxes() {
        var _this = this;
        var scales = this.get("scales");
        var axes = this.get("axes");
        var calculatedTicks = Utils.chart.getTickValues(this.get("_yDomain"), this.get("ticksNumber"));
        var tickValues = this.get("tickValues") || calculatedTicks;
        var tickValues2, y2axis;

        var tickFormat = function tickFormat(symbol, length, formatFn) {
            return function (d, i) {
                var value = _this.tickFormat(formatFn)(d);
                value = Utils.string.convertDashToEnDash(value);
                return symbol && i === length - 1 ? symbol + value : value;
            };
        };

        var xAxis = d3.svg.axis().scale(scales.scale("x")).orient(this.get("xAxisOrient")).tickFormat(function (d) {
            return Utils.string.unmask(d);
        });

        if (this.get('xAxisDateLabel')) {
            xAxis = this.get('dateAxis').getAxis();
        }

        var yAxis = d3.svg.axis().scale(scales.scale("y1")).orient(this.get("y1AxisOrient")).tickSize(this.get("yTickSize")).tickValues(tickValues).tickFormat(tickFormat(this.get("y1TickSymbol"), tickValues.length, this.get("y1TickFormat")));

        yAxis.axisLabel = this.get("y1AxisLabel");
        axes.axis("x", xAxis);
        axes.axis("y1", yAxis);

        if (this.get("y2")) {
            tickValues2 = Utils.chart.getTickValues(this.get("y2Domain"));

            y2axis = d3.svg.axis().scale(scales.scale("y2")).orient(this.get("y2AxisOrient")).tickSize(this.get("yTickSize")).tickValues(tickValues2).tickFormat(tickFormat(this.get("y2TickSymbol"), tickValues2.length, this.get("y2TickFormat")));

            axes.axis("y2", y2axis);
        }
    },

    /**
     * Creates the chart scales
     */
    buildScales: function buildScales() {
        var scales = this.get("scales");
        var canvas = this.get("canvas");

        var xScale = d3.scale.ordinal().domain(this.get("xDomain")).rangeBands([0, canvas.width()], 0.00);

        if (this.get('xAxisDateLabel')) {
            var dateAxis = new DateAxis({
                domain: this.get('xDomain'),
                range: [0, this.get("canvas").width()],
                timeLevel: this.get('timeLevel'),
                orient: this.get('xAxisOrient')
            });
            this.set('dateAxis', dateAxis);
            this.set('xAxisLabels', dateAxis.get('subLabels'));
            xScale = dateAxis.getScale();
        }

        var yScale = d3.scale.linear().domain(this.get("_yDomain")).range([canvas.height(), 0]);

        var x0Scale = d3.scale.ordinal().domain(this.get("x0Domain")).rangeBands([0, xScale.rangeBand() - this.get("barGroupPadding")]);

        scales.scale("x", xScale);
        scales.scale("y1", yScale);
        scales.scale("x0", x0Scale);

        if (this.get("y2")) {
            scales.scale("y2", d3.scale.linear().domain(this.get("y2Domain")).range([canvas.height(), 0]));
        }
    },

    /**
     * Returns the X0 domain used in the grouped bar chart groups.
     */
    getX0Domain: function getX0Domain() {
        var _this = this;
        return this.get("data").get(this.get("y1DataSource"))[0].values.map(function (value) {
            var groupID = _this.get('allowDuplicateDataGroups') ? value.series + value.index : value.series;
            return groupID;
        });
    },

    /**
     * Sets the margin depending on the chart configuration.
     */
    getMargins: function getMargins() {
        var xAxisOrient = this.get("xAxisOrient");
        var xAxisLabels = this.get("xAxisLabels");
        var y1AxisOrient = this.get("y1AxisOrient");
        var y2AxisOrient = this.get("y2AxisOrient");
        var yTickSize = this.get("yTickSize");
        var canvas = this.get("canvas");
        var yAxesLabelWidth = canvas.get("yAxesLabelWidth");
        var yAxesSpacing = this.get("yAxesSpacing");
        var y1AxisLabel = this.get("y1AxisLabel");
        var yPadding = this.get("yPadding");
        var y1Width = !y1AxisLabel ? yTickSize + yPadding : yTickSize + yPadding + yAxesLabelWidth;
        var y2AxisLabel, y2Width;

        var margin = {
            top: xAxisOrient === "top" ? 30 : 5,
            right: y1AxisOrient === "right" ? y1Width + yPadding : yPadding,
            bottom: xAxisOrient === "bottom" ? 25 : 1,
            left: y1AxisOrient === "left" ? y1Width : 0
        };

        if (this.get("y2")) {
            y2AxisLabel = this.get("y1AxisLabel");
            y2Width = !y2AxisLabel ? yTickSize : yTickSize + yAxesLabelWidth;

            if (y1AxisOrient === "left" && y2AxisOrient === "left") {
                margin.left += y2Width + yAxesSpacing;
            } else if (y1AxisOrient === "right" && y2AxisOrient === "right") {
                margin.right += y2Width + yAxesSpacing;
            } else {
                margin.right += y2Width + yPadding;
            }
        }

        if (xAxisLabels && xAxisOrient === "top") {
            margin.top += 15;
        } else if (xAxisLabels && xAxisOrient === "bottom") {
            margin.bottom += 15;
        }

        return margin;
    },

    /**
     * Check for responsive breakpoints
     */
    checkBreakpoints: function checkBreakpoints(newValue, oldValue) {
        var dw = newValue > oldValue;
        var breakpoint = this.get("breakpoint");
        if (dw && oldValue <= breakpoint && newValue > breakpoint || !dw && oldValue > breakpoint && newValue <= breakpoint) {
            this.redoCanvas();
        }
    },

    /**
     * Sets the canvas template depending on the lengend position.
     */
    setCanvasTemplate: function setCanvasTemplate(width) {
        var template;
        if (this.get("legend")) {
            if (width > this.get("breakpoint")) {
                template = "<div class=\"" + Classes.INNER + " " + Classes.INNER + "-right\"></div>\n                    <div class=\"" + Classes.LEGEND + " " + Classes.LEGEND + "-right\"><div class=\"" + Classes.LEGEND + "-inner\"></div></div>";
            } else {
                template = "<div class=\"" + Classes.LEGEND + " " + Classes.LEGEND + "-top\"><div class=\"" + Classes.LEGEND + "-inner\"></div></div>\n                <div class=\"" + Classes.INNER + " " + Classes.INNER + "-top\"></div>";
            }
        }

        this.set("canvasTemplate", template);
    },

    /**
     * Returns the bar padding.
     */
    setBarGroupPadding: function setBarGroupPadding() {
        var data = this.get("data").get(this.get("y1DataSource"));
        var l = data.length;
        var type, length;
        if (this.get("stacked")) {
            type = "standard";
            length = l;
        } else {
            type = "grouped";
            length = l * data[0].values.length;
        }
        var width = this.get("canvas").width();
        var padding = Utils.chart.getBarPadding(length, width, "vertical", type);
        this.set("barGroupPadding", padding);
    },

    /**
     * @override
     */
    beforeCanvas: function beforeCanvas(selection) {
        this.setCanvasTemplate(selection[0][0].offsetWidth);
    },

    /**
     * Force the canvas to be created again using the intended template.
     */
    redoCanvas: function redoCanvas() {
        var canvas = this.get("canvas");
        canvas.remove();
        this.setCanvasTemplate();
        this._createCanvas();
    },

    /**
     * Reloads all the chart's data.
     * @param {Object} dataset Initial dataset object.
     */
    data: function data(dataset) {
        this.get("data").clean();
        this.setData(dataset);
        this.update();
        return this;
    },

    /**
     * Add a series to the bar chart
     * @param {Object} series Object {name: <name of the series>, values: <Array of values for the series>}
     * @example
     * chart.add({
     *      name: "Apple Inc.",
     *      values: [123.5, 56, 34, 54]
     * })
     */
    add: function add(series) {
        this.get("data").set(series.name, series.values, this.get("y1DataSource"));
        this.update();
        return this;
    },

    /**
     * Add benchmarks replacing the existent ones
     * @param {Array} series Object {name: <name of the series>, values: <Array of values for the series>}
     */
    addBenchmark: function addBenchmark(benchmarks) {
        if (!benchmarks) return;
        var datasetName = this.get("benchmarksDataSource");
        var data = this.get("data");
        data.remove(datasetName);
        data.uset({
            name: datasetName,
            series: benchmarks,
            display: this.get("benchmarksDisplayName")
        });

        this.update();
        return this;
    },

    /**
     * Removes a series from the chart.
     * @param {String} seriesName Name of the series to remove from the chart.
     */
    remove: function remove(seriesName) {
        this.get("data").remove(seriesName);
        this.update();
        return this;
    }
});

module.exports = GroupedBarchart;

/***/ })

/******/ });
});